import { TagTypes } from '../../../Api/Types/tagTypes';
import { OfferBoardingPlace } from '../../Shared/Types/offerBoardingPlacesTypes';
import {
  GeneratedOfferBoardingPlaceDto,
  GenerateOfferBoardingPlaceCommand,
} from '../Types/offerBoardingPlacesTypes';
import { offerBoardingPlacesApi } from './offerBoardingPlacesApi';

const extendedOfferBoardingPlacesApi = offerBoardingPlacesApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllForOffer: builder.query<OfferBoardingPlace[], number>({
      async queryFn(offerId, _queryApi, _extraOptions, baseQuery) {
        const result = await baseQuery({
          url: `/offer-boarding-place/offer/${offerId}`,
          method: 'GET',
        });

        const status = (result as any)?.error?.status;
        if (status === 404) {
          return { data: [] };
        }

        if ((result as any)?.error) {
          return { error: (result as any).error };
        }

        return { data: (result as any).data as OfferBoardingPlace[] };
      },
      providesTags: (result, error, offerId) => {
        if (result) {
          return [
            { type: TagTypes.OfferBoardingPlace, id: offerId },
            ...result.map(({ id }) => ({ type: TagTypes.OfferBoardingPlace, id })),
          ];
        }
        return [{ type: TagTypes.OfferBoardingPlace, id: offerId }];
      },
    }),
    assignOfferBoardingPlaceTemplate: builder.mutation<
      void,
      { offerId: number; templateId: number }
    >({
      query: ({ offerId, templateId }) => ({
        url: `/offer-boarding-place/offer/${offerId}/assign-boarding-place-template`,
        method: 'POST',
        body: { offerId, templateId },
      }),
      invalidatesTags: (result, error, { offerId }) => [
        { type: TagTypes.OfferBoardingPlace, id: offerId },
      ],
    }),
    generateOfferBoardingPlace: builder.mutation<
      GeneratedOfferBoardingPlaceDto,
      GenerateOfferBoardingPlaceCommand
    >({
      query: (body) => ({
        url: '/offer-boarding-place/generate',
        method: 'POST',
        body,
      }),
      invalidatesTags: (
        result: GeneratedOfferBoardingPlaceDto | undefined,
        error: unknown,
        { offerId }: { offerId: number }
      ) => {
        if (result) {
          return [
            { type: TagTypes.OfferBoardingPlace, id: offerId },
            ...result.boardingPlaces.map(({ id }) => ({ type: TagTypes.OfferBoardingPlace, id })),
          ];
        }
        return [{ type: TagTypes.OfferBoardingPlace, id: offerId }];
      },
    }),
  }),

  overrideExisting: false,
});
export const {
  useGetAllForOfferQuery,
  useAssignOfferBoardingPlaceTemplateMutation,
  useGenerateOfferBoardingPlaceMutation,
} = extendedOfferBoardingPlacesApi;
